import React, { useEffect } from "react";
import NavBar from "../component/NavBar";
import Footer from "../component/Footer";
import DisclaimerUI from '../component/DisclaimerUI'
import "../assets/css/venobox.css";
import "../assets/css/style.css";

const Disclaimer = () => {
  useEffect(()=>{
    window.scrollTo(0,0)
  },[])
  return (
   <DisclaimerUI/>
  );
};

export default Disclaimer;
